import { Component } from '@angular/core';

@Component({
  selector: 'app-keyboard-arrow-left',
  imports: [],
  templateUrl: './keyboard-arrow-left.component.html',
  styleUrl: './keyboard-arrow-left.component.scss'
})
export class KeyboardArrowLeftComponent {

}
